exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n*[data-v-231e615a] {\n    position: absolute;\n}\n", ""]);

